import { advanceStateSession } from '@/utils/uiSession'

// One dialog serves both create and edit: `selected_profile === null` means create.
//
// `session` is the UI SESSION, in state because the COMPONENT is what closes this dialog: it
// awaits the save and then calls close(). The close button stays enabled while saving, so the
// operator can close and reopen for another profile — and the older response would then shut that
// dialog and discard its edits. See utils/uiSession.js.
export default {
  state: {
    visibility: false,
    selected_profile: null,
    session: 0
  },
  mutations: {
    // The ONE transition path: every mutation that changes which dialog is on screen goes through
    // it, so a new open/close cannot forget to end the previous session.
    INIT_BOOKING_PROFILE_DIALOG(state, payload) {
      state.selected_profile = payload || null
      showDialog(state, true)
    },
    SET_BOOKING_PROFILE_DIALOG_VISIBILITY(state, payload) {
      showDialog(state, payload)
    }
  }
}

function showDialog(state, visible) {
  state.visibility = visible
  advanceStateSession(state)
}
